<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <inputvalidation :formerror="formError" name="name">
        <b-form-checkbox plain id="checkbox1" v-model="formData.isVisible" value="1">{{$t('ISVISIBLE')}}</b-form-checkbox>
      </inputvalidation>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'DocumentCategoriesForm',
  props: ['formData', 'formError'],
  data: function() {
    return {

    }
  },
  created() {
    var me = this;
  },
  methods: {

  },
  computed: {

  }
}
</script>
